import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { customHistory } from "../../framework/customHistory";
import { EventListLine } from "../event/eventListLine";
import { IFrontPageEventState } from "../../models/store/storeTypes";
import { PanelTitle } from "../framework/panelTitle";
import { ToolButton } from "ui/Scripts/source/components/framework/toolButton";
import { Base } from "ui/Scripts/source/framework/base";
import { FrontPageInfoMessage } from "./frontPageInfoMessage";

//FrontPageEvent
export interface IFrontPageEventProps {
    state: IFrontPageEventState;
    loadFrontPageEvent: () => void;
    setLastOpenedEventId: (id: string) => void;
    setReturnUrl: (url: string) => void;
}

export class FrontPageEvent extends React.Component<IFrontPageEventProps, {}> {
    private hasBeenInitialized = false;

    componentDidMount(): void {
        this.props.loadFrontPageEvent();
        this.hasBeenInitialized = true;
    }

    editEvent = (id: string) => {
        this.props.setLastOpenedEventId(id !== Base.emptyGuid ? id : "");
        this.props.setReturnUrl("/front");
        customHistory.push("/event/" + id);
    };

    handleEventLineClick = (id: string) => {
        this.editEvent(id);
    };

    handleAddEvent = () => {
        this.editEvent(Base.emptyGuid);
    };

    render() {
        const props = this.props;
        const events = props.state?.events ?? [];
        return (
            <div className="panelContainer">
                <div className="panel eventPanel">
                    <div className="commandRow">
                        <PanelTitle
                            classes="listTitle link"
                            title={Translations.Events}
                            onClick={() => customHistory.push("/event")}
                        />
                        <div className="buttonContainer flexRight">
                            <ToolButton
                                classes="add white round mono"
                                stopPropagation={true}
                                onClick={this.handleAddEvent}
                            />
                        </div>
                    </div>
                    <div className="panelContent listContainer eventListContainer">
                        <div className="lineContainer mainLineContainer eventList">
                            {this.hasBeenInitialized && !props.state?.isLoading && events.length < 1 &&
                                <FrontPageInfoMessage
                                    message={Translations.NoEventsToShow}
                                />
                            }
                            {events.map((event) => (
                                <EventListLine
                                    key={event.id}
                                    item={event}
                                    selected={false}
                                    first={false}
                                    isLastOpenedEvent={false}
                                    onClick={this.handleEventLineClick}
                                    onLongPress={null}
                                    onRefreshList={null}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}